module.exports = __webpack_public_path__ + "03_long_black.6db73790.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_long_black.png
// module id = glrn
// module chunks = 0